@if (formState | async; as state) {
  <app-unauth-card>
    <h4>Enter your new password</h4>
    <form [formGroup]="form" (submit)="submit()">
      <mat-form-field>
        <mat-label>Reenter your email</mat-label>
        <input
          type="email"
          matInput
          autofocus
          required
          formControlName="email"
          email
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>New password</mat-label>
          <input
            type="password"
            matInput
            autofocus
            formControlName="password"
            required
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Confirm new password</mat-label>
            <input
              type="password"
              matInput
              formControlName="passwordConfirm"
              required
              />
            </mat-form-field>
            <button
              mat-flat-button
              color="primary"
              [disabled]="form.invalid || state.loading"
              >
              @if (!state.loading) {
                Set new password
              }
              @if (state.loading) {
                Please wait...
              }
            </button>
            @if (state.error || localError) {
              <mat-error class="m-t-30">{{
                localError || state.error
              }}</mat-error>
            }
          </form>
        </app-unauth-card>
      }
